import { createSelector } from '@ngrx/store';
import { State } from '@app/core/store/games/games-reducer';
import { State as AppState } from '@app/core/store/reducers';

export const gamesSelector = (state: AppState): State => state.games;

export const selectGames = createSelector(gamesSelector, (state: State) => state.games);
export const selectGamesLoaded = createSelector(gamesSelector, (state: State) => state.gamesLoaded);
